import { CheckCircle, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Grid, styled } from '@mui/material';
import { useState, useEffect, ReactElement } from 'react';
import { Button, WsColors, WsTypoColors, WsTypoVariants, WsTypography } from 'wisestep-base';

import { candidateInteractionMessagingPipelines } from '../../../features/crmSettings/ManageRecruiterActions/helper';

export interface WsButtonGroupProps {
  inputTitle: string;
  buttonsList?: candidateInteractionMessagingPipelines[];
  variant?: 'outlined' | 'text' | 'contained';
  size?: 'small' | 'medium' | 'large';
  selectedIndexValue?: (index: number, value: string) => void;
  selectedMultipleIndexValue?: (index: number[], value: string[]) => void;
  defaultValue?: number;
  defaultMultipleValue?: number[];
  multiple?: boolean;
  triggerReset?: boolean;
  selectedColor?: string;
  leftChild?: ReactElement;
  actions?: string[];
  type?: string;
  results?: string[];
  messagePipeline?: string[];
}
interface ColorProps {
  selectedColor?: string;
  borderColor?: string;
  textColor?: string;
  fontWeight?: string;
}
const BtnStyle = styled(Button)(
  ({ selectedColor, borderColor, textColor, fontWeight }: ColorProps) => ({
    backgroundColor: selectedColor,
    py: 1,
    fontWeight: fontWeight,
    borderRadius: '4px',
    color: textColor,
    borderColor: borderColor,
    textTransform: 'none',
    '&:active': {
      backgroundColor: WsColors.TheBlues50,
    },
    '&:hover': {
      backgroundColor: selectedColor,
      borderColor: selectedColor,
    },
    '&.selected': {
      backgroundColor: selectedColor,
      borderColor: selectedColor,
    },
  })
);

const ButtonGroup = ({
  inputTitle,
  buttonsList,
  selectedIndexValue,
  variant = 'outlined',
  size = 'medium',
  selectedMultipleIndexValue,
  defaultMultipleValue = [],
  multiple = false,
  leftChild,
  actions,
}: WsButtonGroupProps) => {
  const [selectedIndex, setSelectedIndex] = useState<string>();
  const [multipleSelectedIndex, setMultipleSelectedIndex] =
    useState<number[]>(defaultMultipleValue);
  const [multipleSelectedValue, setMultipleSelectedValue] = useState<string[]>(actions ?? []);
  const onChange = (index: number, value: string) => {
    setSelectedIndex(value);
    selectedIndexValue && selectedIndexValue(index, value);
  };

  const onSelect = (index: number, value: string) => {
    let tempSelectedIndex = [...multipleSelectedIndex];
    let tempSelectedValue = [...multipleSelectedValue];
    if (tempSelectedIndex.includes(index)) {
      tempSelectedIndex = tempSelectedIndex.filter((ind) => ind !== index);
      tempSelectedValue = tempSelectedValue.filter((val) => val !== value);
      // if(type="actions"){
      //   tempSelectedValue = temsele.filter(
      //     (e) =>
      //       !getButtonsList1(messagingPipelineData, action, action1).includes(e)
      //   )
      // }
      selectedIndexValue && selectedIndexValue(index, '');
    } else {
      tempSelectedIndex.push(index);
      tempSelectedValue.push(value);
      selectedIndexValue && selectedIndexValue(index, value);
    }
    setMultipleSelectedIndex(tempSelectedIndex);
    setMultipleSelectedValue(tempSelectedValue);
    selectedMultipleIndexValue && selectedMultipleIndexValue(tempSelectedIndex, tempSelectedValue);
  };
  useEffect(() => {
    if (actions?.length == 0) setSelectedIndex('');
    setMultipleSelectedValue(actions ?? []);
  }, [actions]);

  // useEffect(() => {
  //   if (triggerReset && selectedIndex != defaultValue) setSelectedIndex(defaultValue);
  // }, [selectedIndex]);

  const getSelected = (index, btn) =>
    selectedIndex ? selectedIndex === btn : multipleSelectedValue.indexOf(btn) !== -1;
  return (
    <>
      <Grid py={1} display="flex" justifyContent="space-between">
        <WsTypography
          variant={size === 'large' ? WsTypoVariants.SUB_TITLE : WsTypoVariants.BODY1}
          color={WsTypoColors.SECONDARY}
          bold={true}
        >
          {inputTitle}
        </WsTypography>
        {leftChild && <>{leftChild}</>}
      </Grid>
      <Grid item container columnGap={1} rowGap={1}>
        {buttonsList?.map((btn, index) =>
          !multiple ? (
            <BtnStyle
              id={`button_group_${index}`}
              variant={variant}
              size={size}
              key={index}
              onClick={() => onChange(index, btn.name)}
              selectedColor={
                getSelected(index, btn.name) ? btn.color ?? WsColors.TheBlues500 : WsColors.White
              }
              borderColor={
                getSelected(index, btn.name)
                  ? btn.color ?? WsColors.TheBlues500
                  : WsColors.TertiaryShades700
              }
              textColor={getSelected(index, btn.name) ? WsColors.White : WsColors.TertiaryShades700}
              fontWeight={size === 'large' ? '700' : '600'}
              startIcon={getSelected(index, btn.name) ? <CheckCircle /> : <></>}
              endIcon={
                size === 'large' ? (
                  btn.name === selectedIndex ? (
                    <KeyboardArrowUp />
                  ) : (
                    <KeyboardArrowDown />
                  )
                ) : (
                  <></>
                )
              }
            >
              {btn.name}
            </BtnStyle>
          ) : (
            <BtnStyle
              id={`button_group_${index}`}
              variant={variant}
              size={size}
              key={index}
              onClick={() => onSelect(index, btn.name)}
              selectedColor={
                multipleSelectedValue.includes(btn.name)
                  ? btn.color ?? WsColors.TheBlues500
                  : WsColors.White
              }
              borderColor={
                multipleSelectedValue.includes(btn.name)
                  ? btn.color ?? WsColors.TheBlues500
                  : WsColors.TertiaryShades700
              }
              textColor={
                multipleSelectedValue.includes(btn.name)
                  ? WsColors.White
                  : WsColors.TertiaryShades700
              }
              fontWeight={size === 'large' ? '700' : '600'}
              startIcon={multipleSelectedValue.includes(btn.name) ? <CheckCircle /> : <></>}
              endIcon={
                size === 'large' ? (
                  multipleSelectedValue.includes(btn.name) ? (
                    <KeyboardArrowUp />
                  ) : (
                    <KeyboardArrowDown />
                  )
                ) : (
                  <></>
                )
              }
            >
              {btn.name}
            </BtnStyle>
          )
        )}
      </Grid>
    </>
  );
};
export default ButtonGroup;
